export const FACEBOOK_APP_ID = 1624118454533304

export const GROUP_STATUS = {
  CLOSED: 'CLOSED',
  ACTIVE: 'ACTIVE',
}

export const userType = {
  CREATOR: 'CREATOR',
  CONTRIBUTOR: 'CONTRIBUTOR',
}

export enum GroupType {
  CREATED,
  CONTRIBUTED,
}

export const ALLOWED_IMAGE_TYPES: { [key: string]: string[] } = {
  'image/png': ['.png'],
  'image/jpg': ['.jpg', '.jpeg'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/gif': ['.gif'],
}

export const UNALLOWED_ENCODED_IMAGE_TYPES = [
  '52494646', // Webp
  '57454250', // Webp
]

export const COVER_IMAGE_UPLOAD_ERRORS = {
  FILE_INVALID_TYPE: 'file-invalid-type',
  FILE_TOO_LARGE: 'file-too-large',
  FILE_TOO_SMALL: 'file-too-small',
  TOO_MANY_FILES: 'too-many-files',
}

export const COVER_IMAGE_MAX_TOTAL_SIZE = 1600

export const COVER_IMAGE_DEFAULT_IMAGE_URL =
  'https://www.paypalobjects.com/groups/background/default-background.jpg'

// Cover image alternate URLs where were previously in use
export const COVER_IMAGE_ALTERNATE_DEFAULT_IMAGE_URLS = [
  'https://www.paypalobjects.com/groups/default-background.png',
  'https://www.paypalobjects.com/groups/default-background2x.png',
]

export const HEADER_TYPES = {
  SIGNEDIN: 'SIGNEDIN',
  GUEST: 'GUEST',
}

export const ELIGIBILITY_STATES = {
  ELIGIBLE: 'ELIGIBLE',
  INELIGIBLE: 'INELIGIBLE',
}

export const HOME_PATH = '/pool'

export const ERROR_DISPLAY_TYPES = {
  IN_PAGE: 'IN_PAGE',
  FULL_SHEET: 'FULL_SHEET',
  FULLSCREEN: 'FULLSCREEN',
  REDIRECT: 'REDIRECT',
  DISPATCH: 'DISPATCH',
}

export const REGEX = {
  TITLE: /^[\p{L}\p{M}\p{N}\s,.!$':?&\-()\/]{1,70}$/u,
  DESCRIPTION: /^[\p{L}\p{M}\p{N}\s,.!$':?&\-()\/]{1,250}$/u,
}

export const ERROR_CODES = {
  FETCH_ERROR: 'FETCH_ERROR',
  UNABLE_CREATE: 'UNABLE_CREATE',
}

export enum LINK_SOURCE {
  COPY = 0,
  NATIVE = 1,
}

export const PAYPAL_OBJECTS_DIRECTORY = 'https://www.paypalobjects.com'

export const COVER_IMAGE_BORDER_RADIUS = '16px'

export const MEDIA_FILES_CATEGORIES = {
  ALL: 'ALL',
  DEFAULT: 'DEFAULT',
  BIRTHDAY: 'BIRTHDAY',
  WEDDING: 'WEDDING',
  TRIP: 'TRIP',
  GENERIC: 'GENERIC',
}

export const coverImageErrorCodeMapping = {
  [COVER_IMAGE_UPLOAD_ERRORS.FILE_INVALID_TYPE]:
    'imageUploadField.error.invalid.type',
  [COVER_IMAGE_UPLOAD_ERRORS.FILE_TOO_LARGE]:
    'imageUploadField.error.file.too.large',
  [COVER_IMAGE_UPLOAD_ERRORS.FILE_TOO_SMALL]:
    'imageUploadField.error.file.too.small',
}

export const SHEET_SOURCE = {
  CREATE_GROUP_BUTTON: 'createButton',
}
